import { render, staticRenderFns } from "./offline-order-detail.vue?vue&type=template&id=2270d5ff&scoped=true&"
import script from "./offline-order-detail.vue?vue&type=script&lang=js&"
export * from "./offline-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./offline-order-detail.vue?vue&type=style&index=0&id=2270d5ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270d5ff",
  null
  
)

export default component.exports